const domain = 'dev-wu2nu3b0jwkqkb33.us.auth0.com';
const clientId = 'hTP7fDXnQ6sRuoYd6AjMUVfQogqyKeDq';
const redirectUri = window.location.origin;

export const authConfig = {
  domain,
  clientId,
  redirectUri,
};